import pick from 'lodash/pick';
import { REHYDRATE } from 'redux-persist';
import { createSelector } from 'reselect';
/**
 * Created by ok on 6/11/16.
 */
import * as types from './../actions/actionTypes.js';
import {
    errorMessage, updateEntityItemsCache,
} from './../helper/entityReducer';

const categories = (state, action) => {
    switch (action.type) {

        case types.CATEGORIES_REQUESTED:
            return Object.assign({}, state, {
                isFetching: true,
                didInvalidate: false,
                errorMessage: null,
            });

        case types.CATEGORIES_RECEIVED:
            return Object.assign({}, state,
                updateEntityItemsCache(state, action, 'categories'),
            );

        case types.CATEGORIES_REQUEST_FAILED:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: errorMessage(action),
            });

        case types.CATEGORIES_DID_INVALIDATE:
            return state;

        case REHYDRATE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: errorMessage(action),
            });

        case types.LOCALE_CHANGED:
            return Object.assign({}, state, {
                didInvalidate: true,
            });

        default:
            return state;
    }
};

export default categories;

const getCategoriesFromState = state => state.stolo.entities.categories;
export const getActiveCategoryID = state => (
    (
        state.location || {}
    ).payload || {}
).categoryid || null;

export const getCategories = createSelector(
    [getCategoriesFromState, getActiveCategoryID], (categories, categoryid) => {
        // If we have no items, return empty object.
        if (categories.items.length === 0) {
            return {};
        }
        if (categoryid && categories.entities[categoryid].categories) {
            // If the category data contains an categories key, we filter by
            // these subcategories keys.
            return pick(
                categories.entities,
                categories.entities[categoryid].categories,
            );
        }
        //  Return all categories if no specific one is defined.
        return categories.entities;
    });

export const getTopCategories = state => {
    if (state.items && state.items.length !== 0) {
        const TopCategories = {};
        const categories = state.entities;
        for (const category in categories) {
            if (state && !categories[category].containsPatterns) {
                TopCategories[category] = categories[category];
            }
        }
        return TopCategories;
    }
    return {};
};

export const getSubCategories = state => {
    const TopCategories = getTopCategories(state);
    const SubCategories = {};
    for (const topCategory in TopCategories) {
        SubCategories[topCategory] = getSubCategoriesFromCategory(
            state, topCategory);
    }
    return SubCategories || {};
};

export const getSubCategoriesFromCategory = (state, topCategoryId) => {
    let SubCategories = {};

    if (state.items && state.items.length !== 0) {
        const categories = state.entities || {};
        if (topCategoryId && categories &&
            categories[topCategoryId].categories) {
            // If the category data contains an categories key, we filter by
            // these subcategories keys.
            SubCategories = pick(
                categories, categories[topCategoryId].categories);
        }
    }

    return SubCategories || {};
};

export const getCategoryTitle = createSelector(
    [getCategoriesFromState, getActiveCategoryID], (categories, categoryid) => {
        // If we have no items, return empty object.
        if (categories.items.length === 0) {
            return null;
        }
        if (categoryid && categories.entities[categoryid]) {
            return categories.entities[categoryid].longTitle;
        }
        return null;
    });

/**
 * Get the title for a specific categorie from the passed state. But other then
 * for getCategoryTitle selector the categoryid get passed in too and not
 * extracted from state.
 *
 * @param state
 * @param categoryid
 */
export const getCategoryTitleFromState = (state, categoryid) => {
    const categories = getCategories(state);

    if (categoryid && categories[categoryid]) {
        return categories[categoryid].title;
    }

    return null;
};




// WEBPACK FOOTER //
// ./src/reducers/categories.js